/**
 * External dependencies
 */
export default class ConnectionRetailerPayTypes {
    constructor(id, cscom) {
        if (!(this instanceof ConnectionRetailerPayTypes)) {
            return new ConnectionRetailerPayTypes(id, cscom);
        }
        this.cscom = cscom;
        this.id = id;

        if (this.id) {
            this.path = `/user-site-api/user-connection-retailer-pay-types/${this.id}`;
        } else {
            this.path = `/user-site-api/user-connection-retailer-pay-types`;
        }
    }

    getConnectionRetailerPayTypes() {
        return this.cscom.req.get(this.path);
    }
}
